// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc3621de","239":"eab0352a","453":"258b012d","732":"6a6871f6"}[chunkId] + ".chunk.js";
};